import React from 'react'
import { PropTypes } from 'prop-types'
import { Grid, Row, Col } from 'react-flexbox-grid';
import { HtmlHead, PageWrapper, PageContent, Footer, BurgerMenu, SidePanel } from '../../ui'
import bem from '../../../common/bem'
import { checkIsError } from '../../../common/genericHelper'
import SharePanel from '../../../component/ui/SharePanel/SharePanel'

import './DefaultPage.scss'

import StickyBox from "react-sticky-box";

export default class DefaultPage extends React.Component {

  static defaultProps = {
    onMenuChange: () => {},
    curMenuState: false
  }

  static propTypes = {
    route: PropTypes.object,
    curMenuState: PropTypes.bool,
    onMenuChange: PropTypes.func
  };

  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  componentWillMount() {
    //!this.props.curMenuState && this.props.onMenuChange && this.props.onMenuChange(null, true);
  }

  componentWillUpdate(newProps) {
    let nextPath = newProps.location.pathname;
    let currPath = this.props.location.pathname;
    if(nextPath !== currPath) this.loadVideoPlayer()
    !this.props.curMenuState && this.props.onMenuChange && this.props.onMenuChange(null, true);
  }

  loadVideoPlayer(){
    window.videoplayer = null;
    setTimeout(()=>{
      try{
        onYouTubeIframeAPIReady()
      } catch(e){
        console.error(e);
      }
    },100)
  }

  componentDidMount() {
    this.loadVideoPlayer()
  }

  renderVideo(){
    const { route } = this.props;
    const { attributes } = route;
    if(!attributes.video) return;
    let videoScript = JSON.stringify({'source':attributes.video,'timecode':attributes.timecode});
    return (
      <div className={"video__wrapper"}>
        <script id="video_data" type="application/json" dangerouslySetInnerHTML={{ __html: videoScript}} />
        <div id="player" className="player">	</div>
        <div className={"video__over"} id={'video__over'}>
          <div className={"video__inner"}>
            {!!attributes.timecode && (<button className={'button__button button__button--primary'} id={"playVid"}>Play and Follow Video</button>)}
            <button className={'button__button'} id={"playVidOnly"}>Play Video</button>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { curMenuState, onMenuChange, route } = this.props;
    const { html, title, content, attributes, path } = route;

    const isError = checkIsError(this.props);

    if(isError) this.context.router.push('/404')
    let wideSide = false;
    if(!!attributes.video){
      wideSide = true;
    }

    return(
      <PageWrapper isSidebarOpen={this.props.curMenuState}>
        <HtmlHead title={title} />
          <Grid fluid>
            <Row>
              <Col sm={wideSide ? 7 : 9} xs={12}>
                <PageContent className={bem('defaultpage').element('content')}>
                  <BurgerMenu curMenuState={curMenuState} onMenuChange={onMenuChange} />
                  <div dangerouslySetInnerHTML={{ __html: html}} />
                </PageContent>
                <SharePanel loc={path} title={title}/>
              </Col>
              <Col sm={wideSide ? 5 : 3} xs={12}>
                <StickyBox bottom={false}>
                  {this.renderVideo()}
                  <SidePanel content={content} />
                </StickyBox>
              </Col>
            </Row>
          </Grid>
        <Footer />
      </PageWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./component/page/DefaultPage/DefaultPage.js